import type { VersionInfo } from '@this/types/version';

/**
 * Initialize window.APP_VERSION with build metadata
 * This module should be imported at the top of each entry point
 *
 * セキュリティ対策:
 * - debug=true クエリパラメータがある場合のみ設定
 * - enumerable: false でオートコンプリートに表示されない
 */
const initVersion = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  if (params.get('debug') !== 'true') {
    return;
  }

  const latestPr = process.env.LATEST_PR || '';
  const prUrl = latestPr ? `https://github.com/BEST10developers/travel.ai/pull/${latestPr}` : '';

  const versionInfo: VersionInfo = {
    commit: process.env.GIT_COMMIT || 'unknown',
    latestPr,
    prUrl,
    buildTime: process.env.BUILD_TIME || 'unknown',
    commitMessage: process.env.COMMIT_MESSAGE || '',
    version: process.env.VERSION || 'unknown'
  };

  Object.defineProperty(window, 'APP_VERSION', {
    value: versionInfo,
    enumerable: false,
    writable: false,
    configurable: false
  });
};

initVersion();

export { initVersion };
